import { FC, useState, useEffect } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Card, Loader, Typography } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components/AlertBadge';
import { usePaginatedTable } from '@/_shared/components/Table';
import { TableHeader } from '@/_shared/components/TableHeader';
import { EmployerNotCompleted, getEmployeesCall } from '../../state';
import { PAGE_SIZE_IMPORTED_EMPLOYEES } from '../../state/constants';
import { TableEmployees } from './TableEmployees';

export const EditEmployees: FC = () => {
  const t = useTranslations('people.reviewAndFixEmployees');
  const tShared = useTranslations();
  const [selectedProfile, setSelectedProfile] = useState<EmployerNotCompleted | undefined>();
  const {
    loading: loadingGetEmployees,
    error: errorGetEmployees,
    execute: executeGetEmployees,
    totalItems,
  } = getEmployeesCall.hook();

  const [displayedData, setDisplayedData] = useState<EmployerNotCompleted[]>([]);

  const paginedProps = usePaginatedTable({
    rowData: displayedData,
    pageSize: PAGE_SIZE_IMPORTED_EMPLOYEES,
    totalItems,
  });

  useEffect(() => {
    executeGetEmployees({
      complete: false,
      start: 0,
      length: PAGE_SIZE_IMPORTED_EMPLOYEES,
      successSaga: ({ response }) => {
        setDisplayedData(response.data || []);
      },
    });

    return () => {
      executeGetEmployees({
        start: 0,
        length: PAGE_SIZE_IMPORTED_EMPLOYEES,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loadingGetEmployees) {
    return (
      <Box textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (errorGetEmployees) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge iconName='info' type='error' label={message} />;
  }

  return (
    <Card maxWidth='100%' width='100%'>
      <TableHeader title={t('title')} />
      <Typography variant='p2/light' mb='m' color='grey/light'>
        {t('description')}
      </Typography>
      <TableEmployees
        selectedProfile={selectedProfile}
        setSelectedProfile={setSelectedProfile}
        paginedProps={paginedProps}
        setDisplayedData={setDisplayedData}
      />
    </Card>
  );
};
